import { BusinessUnitsModel, BusinessUnitsModelAPI } from '../../../../models';

export const getBusinessUnitsListAdapter = (
    responseAPI: BusinessUnitsModelAPI[]
): BusinessUnitsModel[] => {
    return responseAPI
        ? responseAPI.map((businessUnit) => {
              return {
                  id: businessUnit.id,
                  name: businessUnit.name,
                  externalCompany: businessUnit.externalCompany,
              };
          })
        : [];
};
